/**
 * @file Hook d'initialisation de la devise pour les pages publiques.
 * @module packages.common.hooks.usePublicCurrencyInit
 *
 * Les pages publiques ne disposent pas de sessionStore (utilisateur non authentifié).
 * Ce hook synchronise la devise par défaut des formatters à partir des données
 * de la company reçues via l'API publique.
 */

import {useEffect} from 'react';
import {_setDefaultCurrency} from '../utils/formatNumber';

/**
 * Initialise la devise par défaut des formatters à partir des données company publiques.
 *
 * À appeler une fois par page racine de l'app public, dès que `companyDetails` est disponible.
 *
 * @param {string|undefined} currency - Code devise ISO 4217 issu de companyDetails.currency
 */
export function usePublicCurrencyInit(currency) {
  useEffect(() => {
    if (currency) _setDefaultCurrency(currency);
  }, [currency]);
}
